"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useDeepEqualMemo", {
    enumerable: true,
    get: function() {
        return _useDeepEqualMemo.useDeepEqualMemo;
    }
});
const _useDeepEqualMemo = require("./useDeepEqualMemo");
